// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"ro-z","badgeLink":"so-z","category":"to-z"};